import { render } from "./ModalHeaderNotify.vue?vue&type=template&id=6ad8cdac&scoped=true&ts=true"
import script from "./ModalHeaderNotify.vue?vue&type=script&lang=ts"
export * from "./ModalHeaderNotify.vue?vue&type=script&lang=ts"

import "./ModalHeaderNotify.vue?vue&type=style&index=0&id=6ad8cdac&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ad8cdac"]])

export default __exports__